var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { AutoEntity, removeAutoEntity, setEntityState, } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import { clickedDeleteButton, clickedEditButton, completedPage, } from "../../../lib/Avo";
import AppBody from "../../../components/AppBody";
import { Button } from "@savvyinsure/react-ui";
import { CgSpinner } from "react-icons/cg";
import ConfirmationDialog from "../../../components/ConfirmationDialog";
import { EXPERIENCE } from "../../../constants";
import Header from "../../../components/Header";
import Image from "../../../components/Image";
import { PHASE } from "../../../routeConfig";
import { QueryStatus } from "@reduxjs/toolkit/query";
import { SavvyMaritalStatus } from "@savvyinsure/savvy-auto-policy";
import { genderOptions } from "../../../features/unlinked-application/constants";
import { getAgeFromDOB } from "../../../utils/getAgeFromDOB";
import getVehiclePrimaryText from "../../../features/unlinked-application/components/getVehiclePrimaryText";
import getVehicleSecondaryText from "../../../features/unlinked-application/components/getVehicleSecondaryText";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useHistory } from "react-router-dom";
var selectedOptionText = "Continue";
export default function UnlinkedApplicationAutoReview() {
    var _a = useAppSelector(function (state) { return state.unlinkedApplication; }), policyHolder = _a.policyHolder, drivers = _a.auto.drivers;
    var vehicles = useAppSelector(function (state) { return state.unlinkedApplication.auto.vehicles; });
    var fetchVehicleDataStatus = useAppSelector(function (state) { return state.unlinkedApplication.auto.fetchVehicleData.status; });
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var isPrefill = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.PREFILL; });
    var _b = React.useState(""), typeOfEntityToRemove = _b[0], setTypeOfEntityToRemove = _b[1];
    var _c = React.useState(false), confirmationDialogOpen = _c[0], setConfirmationDialogOpen = _c[1];
    var _d = React.useState(""), entityIdToRemove = _d[0], setEntityIdToRemove = _d[1];
    var push = useHistory().push;
    var dispatch = useAppDispatch();
    var isMissingSpouse = drivers.length === 1 &&
        drivers[0].maritalStatus === SavvyMaritalStatus.Married;
    var invalidDriver = drivers.find(function (driver) { return Object.values(driver).every(Boolean) === false; });
    function getNextRoute() {
        if (isPrefill && (isMissingSpouse || invalidDriver)) {
            return PHASE.UNLINKED_APPLICATION_AUTO_DRIVERS;
        }
        return PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER;
    }
    var policyHolderIsValid = [
        policyHolder.firstName,
        policyHolder.lastName,
        policyHolder.city,
        policyHolder.state,
        policyHolder.zip,
    ].every(Boolean);
    var nextRoute = getNextRoute();
    function handleSubmit(event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                event.preventDefault();
                completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOptionText, optionSelected: selectedOptionText }));
                push(nextRoute);
                return [2 /*return*/];
            });
        });
    }
    function handleCancelConfirmationDialog() {
        setConfirmationDialogOpen(false);
        setEntityIdToRemove("");
    }
    function handleRemoveConfirmationDialog() {
        clickedDeleteButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: typeOfEntityToRemove }));
        dispatch(removeAutoEntity({ entity: typeOfEntityToRemove, id: entityIdToRemove }));
        setConfirmationDialogOpen(false);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, { as: "form", onSubmit: handleSubmit },
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, { className: "pb-[104px]" },
                React.createElement("h2", { className: "mb-6 mt-6 text-xl font-bold leading-6" }, "Review your Auto Policy profile"),
                React.createElement("div", { className: "space-y-6" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "flex items-center" },
                            React.createElement("h3", { className: "flex grow flex-col font-bold" }, "Policy"),
                            !policyHolderIsValid && (React.createElement("div", { className: "flex" },
                                React.createElement(UnlinkedApplicationForm.ListItemActionButton, { key: "edit", icon: React.createElement(Image, { width: "18", height: "18", className: "max-w-none", src: "/assets/icons/pencil.svg" }), onClick: function () {
                                        clickedEditButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: "policy holder" }));
                                        dispatch(setEntityState({
                                            drivers: {
                                                mode: "listing",
                                                editId: "",
                                            },
                                        }));
                                        push(PHASE.UNLINKED_APPLICATION_AUTO_DRIVERS);
                                    } })))),
                        React.createElement("ul", null,
                            React.createElement("li", { className: "relative" },
                                React.createElement("div", { className: "flex w-full items-center py-2 text-left" },
                                    React.createElement("div", { className: "mr-2 flex h-8 w-8 flex-none items-center justify-center" },
                                        React.createElement(Image, { width: "24", height: "24", src: "/assets/icons/profile-blue.svg" })),
                                    React.createElement("div", { className: "flex grow flex-col" },
                                        React.createElement("div", null, [policyHolder.firstName, policyHolder.lastName]
                                            .filter(Boolean)
                                            .join(" "))),
                                    React.createElement("div", { className: "flex items-center" },
                                        React.createElement("div", { className: "flex" },
                                            React.createElement(UnlinkedApplicationForm.ListItemActionButton, { key: "edit", icon: React.createElement(Image, { width: "18", height: "18", className: "max-w-none", src: "/assets/icons/pencil.svg" }), onClick: function (e) {
                                                    e.preventDefault();
                                                    clickedEditButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: "policy holder" }));
                                                    if (drivers[0]) {
                                                        dispatch(setEntityState({
                                                            drivers: {
                                                                mode: "edit",
                                                                editId: drivers[0].id,
                                                            },
                                                        }));
                                                    }
                                                    push(PHASE.UNLINKED_APPLICATION_AUTO_DRIVERS);
                                                } }))))),
                            React.createElement("li", { className: "relative" },
                                React.createElement("div", { className: "flex w-full items-center py-2 text-left" },
                                    React.createElement("div", { className: "mr-2 flex h-8 w-8 flex-none items-center justify-center" },
                                        React.createElement(Image, { width: "24", height: "24", src: "/assets/icons/location-blue.svg" })),
                                    React.createElement("div", { className: "flex grow flex-col" },
                                        React.createElement("div", null, [policyHolder.address1, policyHolder.address2]
                                            .filter(Boolean)
                                            .join(" ")),
                                        React.createElement("div", null, "".concat(policyHolder.city, ", ").concat(policyHolder.state, " ").concat(policyHolder.zip))),
                                    React.createElement("div", { className: "flex items-center" },
                                        React.createElement("div", { className: "flex" },
                                            React.createElement(UnlinkedApplicationForm.ListItemActionButton, { key: "edit", icon: React.createElement(Image, { width: "18", height: "18", className: "max-w-none", src: "/assets/icons/pencil.svg" }), onClick: function (e) {
                                                    e.preventDefault();
                                                    clickedEditButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: "policy holder" }));
                                                    dispatch(setEntityState({
                                                        drivers: {
                                                            mode: "edit",
                                                            editId: drivers[0].id,
                                                        },
                                                    }));
                                                    push(PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_ADDRESS);
                                                } }))))))),
                    React.createElement("div", null,
                        React.createElement("div", { className: "flex items-center" },
                            React.createElement("h3", { className: "flex grow flex-col font-bold" }, "Vehicles"),
                            React.createElement("div", { className: "flex" },
                                React.createElement(UnlinkedApplicationForm.ListItemActionButton, { key: "edit", icon: React.createElement("span", { className: "text-sm font-semibold uppercase text-savvy" }, "Edit"), onClick: function () {
                                        clickedEditButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: AutoEntity.Vehicle }));
                                        push(PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES);
                                    } }))),
                        React.createElement("ul", null, fetchVehicleDataStatus === QueryStatus.pending ? (React.createElement("li", { className: "flex items-center justify-center" },
                            React.createElement(CgSpinner, { className: "mx-auto h-6 w-6 animate-spin", color: "#DBDBDB" }))) : (vehicles.map(function (vehicle) {
                            var make = vehicle.make, model = vehicle.model, year = vehicle.year, trim = vehicle.trim, id = vehicle.id;
                            return (React.createElement(UnlinkedApplicationForm.ListItemWithActionButtons, { key: id, primaryText: getVehiclePrimaryText({ make: make, model: model }), secondaryText: getVehicleSecondaryText({ year: year, trim: trim }), icon: React.createElement(Image, { width: "24", height: "24", src: "/assets/icons/car-blue.svg" }) }));
                        })))),
                    React.createElement("div", null,
                        React.createElement("div", { className: "flex items-center" },
                            React.createElement("h3", { className: "flex grow flex-col font-bold" }, "Drivers"),
                            React.createElement("div", { className: "flex" },
                                React.createElement(UnlinkedApplicationForm.ListItemActionButton, { key: "edit", icon: React.createElement("span", { className: "text-sm font-semibold uppercase text-savvy" }, "Edit"), onClick: function () {
                                        clickedEditButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: AutoEntity.Driver }));
                                        dispatch(setEntityState({
                                            drivers: {
                                                mode: "listing",
                                                editId: "",
                                            },
                                        }));
                                        push(PHASE.UNLINKED_APPLICATION_AUTO_DRIVERS);
                                    } }))),
                        React.createElement("ul", null, drivers.map(function (driver) {
                            var gender = genderOptions.find(function (_a) {
                                var value = _a.value;
                                return value === driver.gender;
                            });
                            return (React.createElement(UnlinkedApplicationForm.ListItemWithActionButtons, { key: driver.id, icon: React.createElement(Image, { width: "24", height: "24", src: "/assets/icons/profile-blue.svg" }), primaryText: "".concat(driver.firstName, " ").concat(driver.lastName), secondaryText: React.createElement(React.Fragment, null, gender === null || gender === void 0 ? void 0 :
                                    gender.label,
                                    " \u00B7",
                                    " ",
                                    getAgeFromDOB(driver.dateOfBirth)) }));
                        }))))),
            React.createElement("div", { className: "absolute bottom-8 left-0 w-full px-6" },
                React.createElement(Button, { disabled: fetchVehicleDataStatus === QueryStatus.pending }, selectedOptionText)),
            React.createElement(ConfirmationDialog, { title: "Remove ".concat(typeOfEntityToRemove), message: "Are you sure you want to remove this ".concat(typeOfEntityToRemove, "? This action cannot be undone."), confirmButtonText: "Remove", cancelButtonText: "Cancel", isOpen: confirmationDialogOpen, onCancel: handleCancelConfirmationDialog, onConfirm: handleRemoveConfirmationDialog, afterLeave: function () { return setTypeOfEntityToRemove(""); }, icon: React.createElement(Image, { width: "48", height: "48", src: "/assets/icons/".concat(typeOfEntityToRemove === AutoEntity.Vehicle ? "car" : "profile", "-blue.svg") }) }))));
}
